export const emailPattern =
  '^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';

export const phonePattern = '[0-9-+ ]*';
export const linkPattern = /([^"=]{2}|^)((https?|ftp):\/\/\S+[^\s.,> )\];'"!?])/;

export const linkTagWrapperPattern = '$1<a href="$2" target="_blank">$2</a>';
